import { useState, useEffect, useRef } from 'react'
import {
    GET_PATIENT_CARD, PATIENT_DOCUMENT_LIST,
    PATIENT_DOCUMENT_ADD, PATIENT_DOCUMENT_DELETE, GET_PATIENT_DOCUMENT, UPDATE_PATIENT_DOCUMENT,
} from '../../../repository/patientRepo'
import { UPLOAD_FILE, } from '../../../repository/common'
import { toast } from "react-toastify"
import useReduxStore from '../../../hooks/useReduxStore'
import { handleTrimmedValue, requiredMessage, requiredSelect } from '../../../Utils'
import { patientFormEnums, modalEnum, fileTypes } from '../../../constant'
import useUploadImage from '../../../hooks/useUploadImage'
const usePatientDocument = () => {
    const { Dispatch, selector: user } = useReduxStore("auth")
    const { Dispatch: patDispatch, selector: PatientData } = useReduxStore("PatientData")
    // const { UploadImage } = useUploadImage()
    const FileRef = useRef()

    const [spinnerDocument, setSpinnerDocument] = useState(false)
    const [patientDocList, setPatientDocList] = useState([])
    const [patientDocFormModal, setPatientDocFormModal] = useState(modalEnum)
    const [patientDocForm, setPatientDocForm] = useState({ documents: [], title: "", description: "" })
    const [patientDocError, setPatientDocError] = useState({})
    const [deletePatDocModal, setDeletePatDocModal] = useState(modalEnum)
    const [filter, setFilter] = useState({ search: "" })
    const [controller, setController] = useState({ page: 1, rowsPerPage: 10 })
    const [totalCount, settotalCount] = useState(0)
    const [patientDocumentModalOpen, setPatientDocumentModalOpen] = useState(false);

    const clearPatDocForm = () => {
        setPatientDocForm({ documents: [], title: "", description: "" })
        setPatientDocError({});
        setPatientDocFormModal(modalEnum)
    }

    // useEffect(() => {
    //     if (PatientData?.id) {
    //         getPatientDocumentList()
    //     }
    // }, [])


    useEffect(() => {
        if (patientDocFormModal?.data?.id) {
            getPatientDocumentDetails()
        }
    }, [patientDocFormModal?.data])

    //  GET PATIENT DOCUMENT DETAILS
    const getPatientDocumentDetails = async () => {
        setSpinnerDocument(true)
        try {
            let response = await GET_PATIENT_DOCUMENT(patientDocFormModal?.data?.id)
            setPatientDocForm({ documents: response?.data?.documents, title: response?.data?.title, description: response?.data?.description })
        } catch (error) {
            toast.error(error.message)
        }
        setSpinnerDocument(false)
    }

    useEffect(() => {
        if (patientDocumentModalOpen) {
            getPatientDocumentList()
        }
    }, [controller,patientDocumentModalOpen])


    //  GET PATIENT DOCUMENT LIST
    const getPatientDocumentList = async () => {
        setSpinnerDocument(true)
        try {
            let payload = {
                count: controller.rowsPerPage,
                page: controller?.page,
                patientId: PatientData?.id,
                searchName: filter?.search || ""
            }
            let response = await PATIENT_DOCUMENT_LIST(payload)
            setPatientDocList(response.data)
            settotalCount(response?.count)

        } catch (error) {
            toast.error(error.message)
            setPatientDocList([])
            settotalCount(0)
        }
        setSpinnerDocument(false)
    }


    const handlePatientDocInput = (event) => {
        const { name, value } = event.target;
        const finalValue = handleTrimmedValue(value);
        setPatientDocForm((prevProps) => ({ ...prevProps, [name]: finalValue }));
        setPatientDocError((pre = {}) => {
            const newErrors = { ...pre };
            if (typeof finalValue === "string" && finalValue.length === 0) {
                return { ...pre, [name]: "This field cannot be empty or contain only spaces." };
            }
            delete newErrors[name];
            return newErrors;
        });

    }

    const handleFileChange = async (e) => {
        const selectedFiles = Array.from(e.target.files);
        setPatientDocForm((prev) => ({ ...prev, documents: [...prev.documents, ...selectedFiles] }));
        await UploadPatDoc(selectedFiles);
    };
    // handle Remove Patient Doc File
    const handleRemovePatDocFile = (index) => {
        setPatientDocForm((prev) => ({
            ...prev,
            documents: prev.documents.filter((_, i) => i !== index), // Remove the selected file by index
        }));
    };
    const UploadPatDoc = async (files, setImgUrl) => {
        const fd = new FormData();
        for (let file of files) {
            if (file.size / 1024 / 1024 > 10) {
                toast.warn("Please upload image less than 10 MB");
                continue;
            }
           
            fd.append('uploadType', "documents");
            fd.append('files', file);
            fd.append('clinicId', user?.clinic_id);
            fd.append('patientId', PatientData?.id);
        }
        setSpinnerDocument(true);
        try {
            let response = await UPLOAD_FILE(fd);
            setPatientDocForm((prev) => ({ ...prev, documents: response?.data?.map((item) => item?.fileName) }))
            setSpinnerDocument(false);
        } catch (error) {
            toast.error(error.message);
        }
        setSpinnerDocument(false);
    };

    // submitPatientDocument
    const submitPatientDocument = async (type = "") => {
        if (!isValidDoc()) return
        let payload = {
            ...patientDocForm,
            patientId: PatientData?.id
        }
        if (type && patientDocFormModal?.data?.id) {
            payload.id = patientDocFormModal?.data?.id
        }
        setSpinnerDocument(true)
        try {
            let response = type == "EDIT" ? await UPDATE_PATIENT_DOCUMENT(payload) : await PATIENT_DOCUMENT_ADD(payload)
            await getPatientDocumentList()
            toast.success(response.message)
            clearPatDocForm()
        } catch (error) {
            toast.error(error.message)
        }
        setSpinnerDocument(false)
    }

    // Delete Patient Card
    const deletePatientCard = async () => {
        try {
            setSpinnerDocument(true)
            let responce = await PATIENT_DOCUMENT_DELETE({ isDeleted: true, id: deletePatDocModal?.data })
            toast.success(responce?.message)
            let pageToSend = controller?.page - 1;
            if (pageToSend < 1) {
                pageToSend = 1;
            }
            setController((prev) => ({
                ...prev,
                page: pageToSend,
            }));
            setDeletePatDocModal(modalEnum)
            getPatientDocumentList()
        } catch (error) {
            toast.error(error?.message)
        }
        setSpinnerDocument(false)
    }

    // Error Message
    const errorMessage = {
        firstName: requiredMessage('first name'),
        lastName: requiredMessage('last name'),
        preferredPronoun: requiredSelect('preferred pronoun'),
        dob: requiredSelect('dob'),
        age: requiredMessage('age'),
        status: requiredSelect('status'),
        preferredContactMethod: requiredSelect('preferred contact method'),
        phone: requiredMessage('Phone number'),
        email: requiredMessage('email'),
        //card key's-------------------------
        cardNumber: requiredMessage("card number"),
        cardLengthMin: 'Card number must be at least 16 digits',
        cardLengthMax: 'Card number must not exceed 19 digits',
        cardHolderName: requiredMessage("card holder name"),
        expiryDate: requiredSelect("expiry date"),
        cvv: requiredMessage("cvv"),
        //insurance key's------------------------
        coverage: requiredSelect("coverage"),
        subscriberFirstName: requiredMessage('first name'),
        subscriberLastName: requiredMessage('last name'),
        subscriberGender: requiredSelect('gender'),
        subscriberDob: requiredSelect('dob'),
        subscriberRelationship: requiredSelect("relationship"),
        patientRelationship: requiredSelect("relationship"),
        groupNo: requiredSelect("group number"),

        insuranceCompanyId: requiredSelect("insurance"),
        issueDate: requiredSelect("issue date"),
        payerId: requiredMessage("payer Id"),
        CpId: requiredMessage("Cp Id"),

        insurance_address1: requiredMessage("street"),
        insurance_address2: requiredMessage("suit/apt number"),
        insuranceRegion: requiredSelect("region"),
        insurance_Zipcode: requiredMessage("zipcode"),
        insurancePlanType: requiredSelect("plan type"),
        // patient document key's------------------
        title: requiredSelect("title"),
    }


    const isValidDoc = () => {
        const errorObj = {}
        if (!patientDocForm?.title) {
            errorObj['title'] = errorMessage['title']
        }
        setPatientDocError(errorObj)

        return !Object.keys(errorObj)?.length
    }


    const resetFilter = () => {
        setController((pre) => ({ ...pre, page: pre.searchPage, searchPage: 1 }))
        setFilter((pre) => ({ ...pre, search: '' }))
    }

    const ApplyFilter = () => {
        setController((pre) => ({ ...pre, searchPage: pre?.page, page: 1 }))

    }

    return {
        dataPatient: {
            patientDocList,
            patientDocFormModal,
            patientDocForm,
            patientDocError,
            FileRef,
            deletePatDocModal,
            filter,
            patientDocumentModalOpen,
            controller,
            totalCount,
            spinnerDocument
        },
        methodsPatient: {
            setPatientDocFormModal,
            handlePatientDocInput,
            handleFileChange,
            submitPatientDocument,
            handleRemovePatDocFile,
            clearPatDocForm,
            deletePatientCard,
            setDeletePatDocModal,
            setFilter,
            resetFilter,
            ApplyFilter,
            setController,
            setPatientDocumentModalOpen
        }
    }
}

export default usePatientDocument